import { Component } from '@angular/core';
import { UserRole } from '../../../common/models/user/user-role.enum';
import { PageTitleService } from '../../../services/page-title.service';

@Component({
  selector: 'psc-user-page-container',
  templateUrl: './user-page-container.component.html',
})
export class UserPageContainerComponent {

  protected readonly UserRole = UserRole;

  constructor(
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.profile)
     */
    this.pageTitleService.setTitle('title.profile');
  }

  public readonly UserProfileTab: typeof UserProfileTab = UserProfileTab;
}

export enum UserProfileTab {
  Profile = 'Profile',
  CompanyProfile = 'CompanyProfile',
  PasswordChange = 'PasswordChange',
  Subscription = 'Subscription',
  Transactions = 'Transactions',
}
